"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRadioGroup = void 0;
const radio_group_1 = require("../../../components/radio-group/radio-group");
const form_field_1 = require("./form-field");
exports.FormRadioGroup = (0, form_field_1.formFieldFactory)(radio_group_1.RadioGroup);
//# sourceMappingURL=form-radio-group.js.map